<div class="container">
  <div class="icon">
    <mat-icon *dtProjectMode="'educational'" inline>list_alt</mat-icon>
    <mat-icon *dtProjectMode="'professional'" inline>filter_list</mat-icon>
  </div>
  <div class="text-container" [class.main-only]="mainDescriptionOnly">
    <div class="description">
      <ng-container *ngTemplateOutlet="descriptionTemplate"></ng-container>
      @if (!decisionData.isProfessional() && !isAssistantOpen) {
        <a class="more" (click)="openAssistant()" i18n>(Mehr Informationen)</a>
      }
    </div>
    @if (!mainDescriptionOnly) {
      <div class="sub-description">
        <ng-container *ngTemplateOutlet="subDescriptionTemplate"></ng-container>
      </div>
    }
  </div>
</div>
